export default __webpack_public_path__ + "static/media/kadra_antek.681eb88c.jpeg";